export class Tuple2<A,B> {
    constructor(a : A, b : B) {
        this.a = a;
        this.b = b;
    }
    a : A;
    b : B;
}
